/**
 * @fileoverview This file was generated by the Angular template compiler. Do not edit.
 *
 * @suppress {suspiciousCode,uselessCode,missingProperties,missingOverride,checkTypes}
 * tslint:disable
 */ 
var styles = ["select[_ngcontent-%COMP%]{width:45%;background-color:#fff;font-size:15px;height:2rem}.mat-dialog-actions[align=end][_ngcontent-%COMP%]{justify-content:flex-end}.mat-dialog-actions[align=center][_ngcontent-%COMP%]{justify-content:center}"];
export { styles as styles };
